<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="ix-table-box mb-3">
                    <table class="ix-table">
                        <thead>
                            <tr>
                                <th>Désignation</th>
                                <th class="text-center" style="width: 120px;">Quantité</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                        <template v-for="(article, index) in articles" v-if="!loading">
                            <tr :key="index">
                                <td>
                                    {{ article.name }}
                                    <input type="hidden" :name="'articles[' + index + '][id]'" v-model="article.id">
                                    <input type="hidden" :name="'articles[' + index + '][name]'" v-model="article.name">
                                </td>
                                <td>
                                    <input type="number" class="form-control form-control-sm text-center" :name="'articles[' + index + '][quantity]'" v-model="article.quantity" required :step="article.has_serial_numbers ? 1 : 0.001" min="0" :id="'quantity' + index" @change="onQuantityInput(article)" :disabled="article.has_serial_numbers">
                                    <input v-if="article.has_serial_numbers" type="hidden" :name="'articles[' + index + '][quantity]'" :value="article.serial_numbers.length">
                                </td>
                                <td class="text-right">
                                    <button type="button" class="btn btn-sm transparent" @click="deleteRow(index)">
                                        <i class="far fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr v-if="article.has_serial_numbers" :key="'sn-' + index">
                                <td colspan="3" style="padding: 0 0 8px 16px;">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div class="font-weight-bold small">Numéros de série</div>
                                        <button type="button" class="ix-btn ix-btn-icon blue btn-sm" @click="addSerialNumberField(article, index)" title="Ajouter un numéro de série">
                                            <i class="far fa-plus"></i>
                                        </button>
                                    </div>
                                    <div class="row">
                                        <div v-for="(sn, snIndex) in article.serial_numbers" :key="snIndex" class="col-md-4 mb-1">
                                            <div class="input-group input-group-sm">
                                                <input type="text" class="form-control sn-input" :name="'articles[' + index + '][serial_numbers][' + snIndex + '][serial_number]'" v-model="sn.serial_number" :id="'sn-' + index + '-' + snIndex" placeholder="Numéro de série" :data-article-id="article.id" required>
                                                <div class="input-group-append">
                                                    <button type="button" class="ix-btn ix-btn-icon blue barcode-trigger" :data-target-input-id="'sn-' + index + '-' + snIndex">
                                                        <i class="far fa-barcode-read"></i>
                                                    </button>
                                                    <button type="button" class="ix-btn ix-btn-icon danger" @click="removeSerialNumberField(article, snIndex, index)" title="Supprimer">
                                                        <i class="far fa-times"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="article.serial_numbers.length === 0" class="alert alert-warning small mb-0 mt-2">
                                        <i class="far fa-exclamation-triangle mr-1"></i> Ajoutez des numéros de série avec le bouton +.
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <tr v-if="loading">
                            <td colspan="2" class="text-center">
                                <i class="far fa-circle-notch fa-spin"></i>
                            </td>
                        </tr>
                        <tr v-show="!loading">
                            <td colspan="100%">
                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." onkeydown="return event.key != 'Enter';" class="form-control" id="articleSearchInput" type="text" v-model="article">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";

    export default {
        name: 'article-seletor',
        props: ['route', 'serialNumbersRoute', 'oldArticles', 'exclude'],
        data() {
            return {
                loading: true,
                article: null,
                articles: []
            };
        },
        methods : {
            addRow: function (article, focus = false) {
                if (this.getCurrentSelectedArticlesId().includes(article.id) == false && (this.exclude == undefined || (this.exclude != undefined && this.exclude != article.id))) {
                    var hasSn = article.has_serial_numbers ? true : false;
                    var serialNumbers = article.serial_numbers ? article.serial_numbers.map(function(sn) {
                        return { serial_number: sn.serial_number !== undefined ? sn.serial_number : sn };
                    }) : [];
                    var qty = article.quantity ? article.quantity : '';

                    if (hasSn) {
                        qty = serialNumbers.length;
                    }

                    this.articles.push({
                        id: article.id,
                        name: article.name,
                        quantity: qty,
                        has_serial_numbers: hasSn,
                        serial_numbers: serialNumbers,
                    })

                    if (focus == true) {
                        setTimeout(() => {
                            $('#quantity' + (this.articles.length - 1)).focus();
                        }, 250)
                    }

                    if (hasSn) {
                        var articleIndex = this.articles.length - 1;
                        this.$nextTick(() => {
                            serialNumbers.forEach((sn, snIndex) => {
                                this.initSnAutocomplete('sn-' + articleIndex + '-' + snIndex, article.id);
                            });
                        });
                    }
                }
            },
            deleteRow: function (index) {
                this.articles.splice(index, 1)
            },
            onQuantityInput: function (article) {
                if (!article.has_serial_numbers) return;
                this.syncSnQuantity(article);
            },
            addSerialNumberField: function (article, articleIndex) {
                article.serial_numbers.push({ serial_number: '' });
                article.quantity = article.serial_numbers.length;
                this.$nextTick(() => {
                    this.initSnAutocomplete('sn-' + articleIndex + '-' + (article.serial_numbers.length - 1), article.id);
                });
            },
            removeSerialNumberField: function (article, snIndex, articleIndex) {
                article.serial_numbers.splice(snIndex, 1);
                article.quantity = article.serial_numbers.length;
            },
            syncSnQuantity: function (article) {
                article.quantity = article.serial_numbers.length;
            },
            initSnAutocomplete: function (snInputId, articleId) {
                var self = this;
                var $input = $('#' + snInputId);
                if ($input.length === 0 || $input.data('sn-autocomplete') === true) return;
                $input.data('sn-autocomplete', true);

                var parts = snInputId.split('-');
                var articleIndex = parseInt(parts[1]);
                var currentSnIndex = parseInt(parts[2]);

                $input.autocomplete({
                    minLength: 1,
                    source: function (request, response) {
                        var url = self.serialNumbersRoute.replace('ARTICLE_ID', articleId);
                        $.ajax({
                            url: url,
                            type: 'get',
                            dataType: 'json',
                            headers: self.getHttpJsonRequestHeaders().headers,
                            data: { q: request.term },
                            success: function (data) {
                                var usedSn = [];
                                if (self.articles[articleIndex] && self.articles[articleIndex].serial_numbers) {
                                    self.articles[articleIndex].serial_numbers.forEach(function (sn, idx) {
                                        if (idx !== currentSnIndex && sn.serial_number && sn.serial_number.trim() !== '') {
                                            usedSn.push(sn.serial_number);
                                        }
                                    });
                                }
                                var filtered = data.filter(function (item) {
                                    return usedSn.indexOf(item.serial_number) === -1;
                                });
                                response($.map(filtered, function (item) {
                                    return {
                                        label: item.serial_number,
                                        value: item.serial_number
                                    };
                                }));
                            }
                        });
                    },
                    select: function (event, ui) {
                        $input.val(ui.item.value);
                        $input[0].dispatchEvent(new Event('input'));
                    }
                }).focus(function () {
                    $input.autocomplete('search', '');
                });
            },
            initAllSnAutocomplete: function () {
                var self = this;
                this.articles.forEach(function (article, index) {
                    if (article.has_serial_numbers) {
                        article.serial_numbers.forEach(function (sn, snIndex) {
                            self.initSnAutocomplete('sn-' + index + '-' + snIndex, article.id);
                        });
                    }
                });
            },
            onQuantityChange: function (article) {
            },
            getCurrentSelectedArticlesId: function() {
                return this.articles.map(article => article.id);
            }
        },
        mounted(){
            $("#articleSearchInput").autocomplete({
                minLength: 2,
                source: (request, response) => {
                    $.ajax({
                        url : this.route,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedArticlesId().join(';') + (this.exclude != undefined ? (';' + this.exclude) : '') },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.name,
                                    value: item.name,
                                    number: item.number,
                                    reference: item.reference
                                })
                            }))
                        }
                    });
                },
                 create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        var number = item.number ? item.number : 'Non renseigné'; 
                        var html = `<div class="d-flex align-items-center">
                                      <span class="badge badge-secondary">${number}</span>
                                      <span class="ml-2">${item.name}</span>`;

                        if(item.reference){
                             html += `<span class="ml-auto">${item.reference}</span>
                                    </div>`
                        }
                       

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.article = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.addRow(item.item, true)

                        $(e.target).val("")
                        this.article = null
                    }
                }
            }).focus(() => {
                $("#articleSearchInput").autocomplete("search", '');
            });

            const jsonArticleBackup = JSON.parse(this.oldArticles)
            if (Array.isArray(jsonArticleBackup)) {
                if (jsonArticleBackup.length > 0) {
                    jsonArticleBackup.forEach(article => {
                        this.addRow(article)
                    })
                }
            }
            this.loading = false

            this.$nextTick(() => {
                this.initAllSnAutocomplete();
            });
        }
    }
</script>
